/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */
import React, {
  ChangeEvent,
  FC,
  useCallback,
  useEffect,
  useState,
} from 'react';
import classNames from 'classnames';
import { t } from '../../../i18n';
import formInputs from './constants';
import styles from './styles.module.scss';
import { Textarea } from '../../inputs/Textarea';
import { usePathPrefix } from '../../../constants/hooks';
import { TextInputWithIcon } from '../TextInputWithIcon';
import { AttachInput, AttachInputValue } from '../../inputs/AttachInput';
import { Checkbox } from '../../inputs/Checkbox';
import { getFromUrl } from '../../../utils/getFromUrl';
import { Button } from '../../main/Button';

type IProps = {
  onSubmit: (values: Record<string, any>) => void;
  className?: string;
  withFile?: boolean;
  withSubscribe?: boolean;
  actionButtonName?: string;
  formId: string;
  isLoading?: boolean;
  isFormSucces: boolean;
};

const OrderForm: FC<IProps> = ({
  onSubmit,
  className,
  withFile,
  withSubscribe,
  actionButtonName,
  formId,
  isLoading,
  isFormSucces,
}) => {
  const prefix = usePathPrefix();
  const path = getFromUrl();

  const [subscribe, setSubscribe] = useState(true);
  const [inputsState, setInputsState] = useState<Record<string, string>>({});
  const [errors, setErrors] = useState<Record<string, boolean>>({});
  const { name, company, phone, email, comment, from } = inputsState;

  const [file, setFile] = useState<AttachInputValue>({
    name: '',
    content: null,
  });

  const validateFields = useCallback(() => {
    const errors = {
      name: !name || name.length <= 2,
      company: !company || company.length <= 2,
      phone: !phone || phone.length <= 14,
    };
    setErrors(errors);

    // TODO: Remove old file validation, need added new file validation

    return !Object.values(errors).some((val) => val);
  }, [name, company, phone, email, comment, setErrors]);

  const [isSuccess, setIsSuccess] = useState(false);

  const onChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name } = e.target;
    const { value } = e.target;
    if (errors[name])
      setErrors((prevState) => ({ ...prevState, [name]: false }));

    setInputsState((prevState) => ({ ...prevState, [name]: value }));
  };

  const handleSubmit = useCallback(
    (event) => {
      event.preventDefault();

      if (!validateFields()) return;

      onSubmit({
        ...inputsState,
        file: file.content || new ArrayBuffer(0),
        filename: file.name,
        subscribe: subscribe || '',
        captcha: '',
        from,
      });
    },
    [validateFields]
  );

  useEffect(() => {
    if (isFormSucces) {
      setIsSuccess(true);
      setInputsState((prevState) =>
        Object.fromEntries(Object.keys(prevState).map((el) => [el, '']))
      );
    }
  }, [isFormSucces]);

  return (
    <>
      <div
        id="contact"
        className={classNames('container', className)}
        style={{ width: '100%' }}
      >
        <form
          className={styles.form}
          onSubmit={handleSubmit}
          id={`order_form_${formId}`}
        >
          {formInputs.map(({ name, label, icon }) => (
            <TextInputWithIcon
              id={`${path}-${name}`}
              name={name}
              value={inputsState[name] ?? ''}
              handler={onChange}
              label={label}
              icon={`${prefix}${icon}`}
              hasError={errors[name]}
              key={name}
              isSuccess={isSuccess}
            />
          ))}

          <div className={styles.form__textarea}>
            <Textarea
              id={`${path}-comment`}
              name="comment"
              value={inputsState.comment ?? ''}
              handler={onChange}
              placeholder="order.textarea_placeholder"
            />
          </div>
          <input type="hidden" name="from" id="from" value={path} />
          {(withFile ?? withSubscribe) && (
            <div className={styles.fields}>
              {withFile && (
                <AttachInput
                  id={`${path}-attachment`}
                  label=""
                  value={file}
                  handler={setFile}
                />
              )}
              {withSubscribe && (
                <div className={styles.checkbox_wrap}>
                  <Checkbox checked={subscribe} handler={setSubscribe} />
                  <p>{t('order.subscribe')}</p>
                </div>
              )}
            </div>
          )}
          <div className={styles.button__wrapper}>
            <Button
              size="big"
              fullWidth
              isLoading={isLoading}
              disabled={isLoading}
            >
              {actionButtonName
                ? t(actionButtonName)
                : t('cases.restocare.contact.send')}
            </Button>
          </div>
        </form>
      </div>
    </>
  );
};

export { OrderForm };
